"use client";

import React from "react";
import { useTranslations } from "next-intl";

export interface FilterQueryPrinterProps {
  searchQuery?: string;
  filters?: {
    [key: string]: Array<string> | string;
  };
  entityString: string;
  disableAllPrefix?: boolean;
}

const normalizeValue = (value: string | Array<string>, t): string => {
  if (!value) return "";
  if (Array.isArray(value)) {
    const validValues = value?.filter(Boolean);
    if (!validValues?.length) return "";
    if (validValues.length === 1) return validValues[0];
    if (validValues.length === 2) return validValues.join(` ${t("or")} `);
    const cloneValue = [...validValues];
    const lastItem = cloneValue.pop();
    return `${cloneValue.join(", ")} ${t("or")} ${lastItem} `;
  }
  return value;
};

const FilterQueryPrinter: React.FC<FilterQueryPrinterProps> = ({
  entityString,
  filters,
  searchQuery,
  disableAllPrefix,
}) => {
  const t = useTranslations();

  const textChunks = [];
  const values = {};

  Object.entries(filters || {}).forEach(([key, rawValue], index) => {
    const value = normalizeValue(rawValue, t);
    if (!value) return;
    const isValueBoolean = value === "true";
    if (isValueBoolean) {
      textChunks.push(
        <span key={`${key}-${textChunks.length}`}>
          {!searchQuery && textChunks.length === 0 ? t("with") : " " + t("and")}{" "}
          <b>{key} </b>
        </span>,
      );
    } else {
      if (value.length > 30) {
        values[key] = `${value.substring(0, 30)} ...`;
      } else {
        values[key] = value;
      }
    }
  });
  const filterKeys = Object.keys(values);
  if (filterKeys.length) {
    filterKeys.forEach((key) => {
      if (values[key])
        textChunks.push(
          <span key={`${key}-${textChunks.length}`}>
            {!searchQuery && textChunks.length === 0
              ? t("with")
              : " " + t("and")}{" "}
            {key} <b>&#34;{values[key]}&#34;</b>
          </span>,
        );
    });
  }

  const showAll = !disableAllPrefix && !textChunks?.length && !searchQuery;

  return (
    <div className="filter-query-printer mb-3 mb-lg-0">
      {showAll && <>{t("all")}&nbsp;</>}
      <b>{entityString}</b>&nbsp;
      {searchQuery && (
        <>
          {t("with")} <b>&#34;{searchQuery}&#34;</b>&nbsp;
        </>
      )}
      {textChunks}
    </div>
  );
};

export default FilterQueryPrinter;
